import React, { useState } from "react";
import styles from "./Carousel.module.css";
import Right from "../../assests/popup/ryt.svg";
import Left from "../../assests/popup/lftw.svg";
import ReactPlayer from "react-player";

function Carousel({ items }) {
  const [currentItem, setCurrentItem] = useState(0);
  const prevItem = () => {
    setCurrentItem((prev) => (prev === 0 ? items?.length - 1 : prev - 1));
  };

  const nextItem = () => {
    setCurrentItem((prev) => (prev === items?.length - 1 ? 0 : prev + 1));
  };

  const isPrevDisabled = currentItem === 0;
  const isNextDisabled = currentItem === items?.length - 1;
  return (
    <div className={styles.carouselContainer}>
      <div className={styles.carouselSlide}>
        {items && items[currentItem]?.fileType?.startsWith("image") && (
          <img
            src={items[currentItem]?.fileUrl}
            alt={`Image `}
            className={styles.active}
          />
        )}
        {items && items[currentItem]?.fileType?.startsWith("video") && (
          <ReactPlayer
            config={{
              file: { attributes: { controlsList: "nodownload" } },
            }}
            playing={false}
            controls={true}
            width="100%"
            height="100%"
            url={items[currentItem]?.fileUrl}
            className={styles.active}
          />
        )}
      </div>

      <button
        onClick={prevItem}
        disabled={isPrevDisabled}
        className={`left-0 ${styles.button}`}
      >
        <img src={Left} />
      </button>
      <button
        onClick={nextItem}
        disabled={isNextDisabled}
        className={`right-0 ${styles.button}`}
      >
        <img src={Right} />
      </button>
    </div>
  );
}

export default Carousel;
